import { NewsRPMInstanceArticleDetailItemSchema, NewsRPMInstanceArticleListItemSchema } from "#root/schema/platform/newsrpm-instance";
import RemoteCollection from "#root/utility/remote-collection";
import { z } from "zod";

export const SyndicatedContentTrackingListItemSchema = z.object({
  networkCode: z.string(),
  network: z
    .object({
      name: z.string().nullish(),
    })
    .nullish(),
  sites: z
    .array(
      z.object({
        name: z.string(),
        url: z.string().nullish(),
        headline: z.string(),
        link: z.string().nullish(),
      }),
    )
    .nullish(),
});

export function getTrackingCollectionForSlug(slug: string) {
  return new RemoteCollection(
    `/api/account/self/syndicatedContent/tracking/${slug}/sites`,
    SyndicatedContentTrackingListItemSchema,
    SyndicatedContentTrackingListItemSchema,
  );
}

export function createProviderArticleCollection(providerCode: string) {
  return new RemoteCollection(
    `/api/account/self/syndicatedContent/provider/${providerCode}/articles`,
    NewsRPMInstanceArticleListItemSchema,
    NewsRPMInstanceArticleDetailItemSchema,
  );
}